import React from "react";
// import { Link } from 'react-router-dom'
import Project from "../components/Project";
import { RoomContext } from "../context";
// potřebuju sem dostat API, z toho vzít vždy určitý type (kitchen, room, etc.) a vyrenderovat ho

import NavbarClear from "../components/NavbarClear";
import SideHero from "../components/SideHero";
// import Figure from '../components/Figure'
import Filter from "../components/Filter";
import Cta from "../components/Cta";
import Footer from "../components/Footer";

export default class Projects extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  static contextType = RoomContext;
  render() {
    let i = 1;
    let { projects } = this.context;
    projects = projects.map((project) => {
      if (project.type === "") {
        return (
          <Project key={project.id} project={project} type={project.type} />
        );
      } else if (i === 1) {
        i = 2;
        return <p className={"choose"}>Vyberte prosím kategorii.</p>;
      }
    });

    return (
      <div className="offWhiteBackground">
        <NavbarClear logo="https://www.nabytekbatka.cz/BatkaSmall.svg" />
        <SideHero />
        <h1 className="projects-title">ukázky naší práce</h1>
        <Filter />
        <div>{projects}</div>
        <Cta />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Projects.js